import { ChakraProvider } from "@chakra-ui/react";
import { MotionConfig } from "framer-motion";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

// theme
import { theme } from "./theme";

// pages
import LoginPage from "./pages/login";
import ApplicationsPage from "./pages/applications";
import ContractsPage from "./pages/contracts";
import TicketsPage from "./pages/tickets";
import AppWrapper from "./components/appWrapper";

// styles
import "./styles/main.scss";

/**
 * MotionConfig sits outside ChakraProvider so Chakra's own framer transitions (Modal, Drawer, Popover, Tooltip
 * and the toast region) also skip transform/layout animation when the user prefers reduced motion.
 */
export const App = () => (
  <MotionConfig reducedMotion="user">
    <ChakraProvider
      theme={theme}
      toastOptions={{ defaultOptions: { position: "bottom-right", variant: "soft", isClosable: true, duration: 4000 } }}
    >
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route element={<AppWrapper />}>
            <Route path="/" element={<ApplicationsPage />} />

            <Route path="/contracts" element={<ContractsPage />} />

            <Route path="/tickets" element={<TicketsPage />} />
          </Route>
        </Routes>
      </Router>
    </ChakraProvider>
  </MotionConfig>
);
